import { useEffect, useRef } from "react";

import { Burger } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconBrandWhatsapp } from "@tabler/icons-react";
import ModalPop from "../../home/ModalPop";

export const HeaderCategoryList = [
  {
    id: 1,
    title: `키플레이어`,
    link: "#about",
  },
  {
    id: 2,
    title: `서비스\u00A0목록`,
    link: "#service",
  },
  {
    id: 3,
    title: `BLOG\u00A0작업사례`,
    link: "https://blog.naver.com/brucelee1215",
  },
  {
    id: 4,
    title: `365일\u00A024시간\u00A0긴급출동`,
    link: "pop",
  },
  {
    id: 5,
    title: `상세\u00A0견적문의`,
    link: "#contact",
  },
];

const MHeader = () => {
  const [opened, { toggle }] = useDisclosure(false);

  const phoneMenuListRef = useRef<HTMLDivElement>(null);
  const burgerIconRef = useRef<HTMLButtonElement>(null);
  const headerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    burgerIconRef.current?.addEventListener("click", () => {
      opened
        ? (phoneMenuListRef.current!.style.transform = "translate(0, -120%)")
        : (phoneMenuListRef.current!.style.transform = "translate(0, 0)");
    });
  }, [opened]);

  const menuOnclick = (link: string) => {
    let menuHeight =
      document.querySelector<HTMLDivElement>("#header")!.offsetHeight;

    var location = document.querySelector<HTMLDivElement>(link)!.offsetTop;

    window.scrollY &&
      window.scrollTo({
        top: location - menuHeight + 120,
        behavior: "smooth",
      });
  };

  const phoneMenuOnclick = (link: string) => {
    let menuHeight =
      document.querySelector<HTMLDivElement>("#header")!.offsetHeight;

    var location = document.querySelector<HTMLDivElement>(link)!.offsetTop;

    window.scrollY &&
      window.scrollTo({
        top: location - menuHeight,
        behavior: "smooth",
      });

    toggle();
    phoneMenuListRef.current!.style.transform = "translate(0, -100%)";
  };

  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };

  return (
    <>
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
      <header className="fixed left-0 top-0 w-full h-fit z-10 ">
        <div
          ref={headerRef}
          id="header"
          // style={headerStyle}
          className="relative w-full h-fit px-2 lg:px-[calc((100%-var(--container))/3)] max-h-20 lg:max-h-32 py-2 lg:pb-0 lg:pt-5 overflow-hidden bg-white z-40"
        >
          <div className="relative w-full h-full flex justify-between items-center gap-6 xl:gap-4 pt-2">
            <Burger
              ref={burgerIconRef}
              opened={opened}
              onClick={toggle}
              className="block xl:hidden"
              size="md"
              color="black"
            />
            <div className="flex items-center gap-3">
              <div className="relative w-auto h-full">
                <img
                  alt="키플레이어 도어락 로고"
                  onClick={() => (window.location.href = "/")}
                  className="!relative w-auto h-full max-h-8 lg:max-h-10 xl:max-h-12 py-1 lg:pb-2 object-contain cursor-pointer"
                  src="/images/logo.png"
                  width={341}
                  height={113}
                />
              </div>
              <p className="hidden lg:block relative w-fit h-fit bg-primary text-white rounded-full px-2 pt-0.5">
                <span className="text-point">열쇠복사와 차문잠김 문제</span>는
                다루지 않습니다.
              </p>
            </div>
            <div className="block xl:hidden relative w-fit h-fit p-1 mx-1 rounded-full">
              <IconBrandWhatsapp
                onClick={() => {
                  window.location.href = "tel:010-8799-3313";
                }}
                size={30}
                stroke={1}
                className="text-primary"
              />
            </div>
            <div className="hidden xl:block relative w-fit h-fit">
              <img
                onClick={() => {
                  window.location.href = "tel:010-8799-3313";
                }}
                className="!relative w-full h-full max-h-10 lg:max-h-12 xl:max-h-16 lg:pb-3 object-contain cursor-pointer"
                alt="키플레이어 전화 상담 010-8799-3313"
                src={"images/rightNum.png"}
                width={525}
                height={116}
              />
            </div>
          </div>
        </div>
        <div className="hidden xl:block relative w-full h-fit lg:px-[calc((100%-var(--container))/3)] overflow-hidden z-40 border-t border-b bg-white">
          <ul className="hidden relative w-full h-fit max-w-screen-lg xl:max-w-screen-3xl mx-auto text-center xl:grid items-center justify-items-center grid-cols-5 cursor-pointer">
            {HeaderCategoryList.map((v, i) => (
              <li
                key={i + "pc"}
                onClick={() => {
                  v.link.includes("#")
                    ? menuOnclick(v.link)
                    : v.link.includes("pop")
                      ? openfunc()
                      : window.open(v.link);
                }}
                className="text-center relative w-full h-fit bg-white py-2"
              >
                <p>{v.title}</p>
              </li>
            ))}
          </ul>
        </div>
        <div
          ref={phoneMenuListRef}
          className="block xl:hidden fixed top-16 left-0 w-full h-full -translate-y-full transition-transform duration-500 z-30"
        >
          <ul className="border-b bg-white text-font">
            {HeaderCategoryList.map((v, i) => (
              <li
                key={i}
                onClick={() => {
                  v.link.includes("#")
                    ? phoneMenuOnclick(v.link)
                    : v.link.includes("pop")
                      ? openfunc()
                      : window.open(v.link);
                }}
                className="border-b py-4 text-center"
              >
                <p>{v.title}</p>
              </li>
            ))}
          </ul>
        </div>
      </header>
    </>
  );
};

export default MHeader;
